import React, { useEffect } from 'react';
import PageTitle from '../components/common/PageTitle';
import { subscriptionPlans } from '../data/subscriptionPlans';
import SubscriptionPlanCard from '../components/subscription/PlanCard'; // Import directly 
import SubscriptionFAQ from '../components/subscription/SubscriptionFAQ';

const SubscribePage: React.FC = () => {
  useEffect(() => {
    document.title = 'Subscribe to Legal Nest Premium';
  }, []);

  const handleSubscribe = (planId: string) => {
    console.log(`Subscribing to ${planId} plan`);
    // Implement subscription logic here
  };

  return (
    <div className="container-custom py-10 px-4">
      <PageTitle title="Subscribe to Legal Nest Premium" />
      
      <div className="max-w-4xl mx-auto mb-10">
        <p className="text-center text-neutral-600 mb-8">
          Unlock exclusive content, in-depth analysis, and powerful tools to enhance your legal knowledge and practice.
        </p>
      </div>
      
      {/* Plans grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
        {subscriptionPlans.map((plan) => (
          <SubscriptionPlanCard
            key={plan.id}
            plan={plan}
            onClick={handleSubscribe}
            buttonText="Subscribe Now"
          />
        ))}
      </div>
      
      {/* FAQ Section */}
      <SubscriptionFAQ />
    </div>
  );
};

export default SubscribePage;